export default {
  logistics: {
    breadcrumbHome: 'Faqja kryesore',
    breadcrumbSolutions: 'Zgjidhjet',
    breadcrumbCurrent: 'Magazina dhe logjistika',
    hero: {
      eyebrow: 'Magazina dhe logjistika',
      title: 'Mbikëqyrje e sipërfaqeve të mëdha për logjistikën dhe magazinat',
      lead: 'Kënd i gjerë, PTZ dhe shikim nate – mbulojmë salla të mëdha dhe zona të jashtme me pak kamera të vendosura mirë.',
    },
    areas: {
      title: 'Zonat e mbikëqyrjes në magazinë dhe logjistikë',
      lead: 'Nga hyrja te paketimi: e strukturojmë mbikëqyrjen tuaj përgjatë rrjedhës së mallrave – pa boshllëqe.',
      items: {
        '0': { title: 'Hyrja dhe dalja', desc: 'Çdo automjet që kalon në territorin tuaj kapet – me targë dhe vulë kohe për dokumentim të plotë.' },
        '1': { title: 'Zona e dorëzimit', desc: 'Ardhja dhe tërheqja e mallrave janë momente të ndjeshme. Kamerat dokumentojnë çdo lëvizje në rampë.' },
        '2': { title: 'Raftet', desc: 'Sallat e mëdha kërkojnë zgjidhje të mëdha. Kamerat PTZ kalojnë korridoret dhe zmadhojnë deri te paleta.' },
        '3': { title: 'Përgatitja e porosive', desc: 'Paketimi dhe përgatitja karakterizohen nga lëvizja. Kamerat e pamjes së plotë qartësojnë ankesat.' },
        '4': { title: 'Jashtë dhe oborri', desc: 'Perimetri është vija e parë e mbrojtjes. Kamera rezistente mbikëqyrin gardhet, portat dhe automjetet.' },
        '5': { title: 'Zyra dhe administrata', desc: 'Edhe zona administrative ka nevojë për mbrojtje – për vlerat, dokumentet dhe hyrjet e ndjeshme.' },
      },
    },
    coverage: {
      eyebrow: 'Sipërfaqe të mëdha nën vëzhgim',
      title: 'Një kamerë, efekt i madh',
      lead: 'Në magazina ka rëndësi pamja e plotë. Në vend të shumë kamerave të veçanta, përdorim teknologji që mbulon sipërfaqe të mëdha me inteligjencë.',
      items: {
        '0': { title: 'Kamera PTZ', desc: 'Rrotullim, pjerrësi, zmadhim – një kamerë mbulon sipërfaqe të mëdha dhe jep detaje kur duhet.' },
        '1': { title: 'Pamje me kënd të gjerë', desc: 'Për seksionet e sallës dhe zonat e jashtme: kamera kompakte me kënd të gjerë kapin zona të mëdha në një imazh.' },
        '2': { title: 'Shikim ditën dhe natën', desc: 'Infra të kuqe dhe sensorë shumë të ndjeshëm japin pamje të përdorshme edhe në errësirë – 24 orë.' },
      },
    },
    roundClock: {
      eyebrow: 'Gjatë gjithë kohës',
      title: 'Regjistrim që nuk fle kurrë',
      lead: 'Trafiku i mallrave nuk ndalet natën. Sistemi juaj regjistron gjatë gjithë kohës dhe i bën ngjarjet menjëherë të gjetura.',
      list: {
        '0': 'Regjistrim 24/7 në regjistrues lokal me afat të përcaktuar',
        '1': 'Regjistrimi sipas ngjarjeve kursen hapësirë dhe lehtëson kërkimin',
        '2': 'Përcjellje alarmi te persona të përcaktuar te lëvizjet në zona të ndaluara',
        '3': 'Mirëmbajtje e rregullt nga SSG Care për disponueshmëri të qëndrueshme',
        '4': 'E zgjerueshme me kamera shtesë dhe lokacione të tjera',
      },
      note: 'Shënim: afati i ruajtjes së regjistrimeve duhet përshtatur me kërkesat operacionale e ligjore. Ju këshillojmë për këtë.',
    },
    cta: {
      title: 'Logjistika juaj – e dokumentuar pa boshllëqe',
      lead: 'Analizojmë rrjedhat e mallrave dhe pikat e rrezikut dhe planifikojmë një sistem që i përshtatet strukturës së sallës suaj.',
      primary: 'Rezervoni një takim konsultimi',
      secondary: 'Zbuloni SSG Care',
    },
  },
};